module.exports = __webpack_public_path__ + "assets/images/img/03.37708627689b20f01d8e576027e5c196.jpg";